function unitLabel(unit) {
  return String(unit || "").toLowerCase();
}

export function formatRir(rir) {
  if (rir == null) return "";
  return `RIR ${rir === 5 ? "5+" : rir}`;
}

export function formatLoad(load) {
  if (!load) return "";
  const amount = load.value;
  const unit = unitLabel(load.unit);
  if (load.convention === "PER_SIDE") return `${amount} ${unit}/side`;
  if (load.convention === "ADDED") return `+${amount} ${unit}`;
  if (load.convention === "ASSISTANCE") return `Assist ${amount} ${unit}`;
  return `${amount} ${unit}`;
}

export function formatPerformedValue({
  measurementType,
  load,
  reps,
  seconds,
  rir,
  cardioMinutes,
} = {}) {
  if (measurementType === "CARDIO_MINUTES") return `${cardioMinutes} min`;
  const rirText = formatRir(rir);
  if (measurementType === "TIMED_HOLD") {
    return [formatLoad(load), `${seconds} s`].filter(Boolean).join(" · ");
  }
  const loadText = formatLoad(load);
  const repsText = reps == null ? "" : loadText ? String(reps) : `${reps} reps`;
  const performed = loadText && repsText
    ? `${loadText} × ${repsText}`
    : loadText || repsText;
  return [performed, rirText].filter(Boolean).join(" · ");
}
